module.exports = __webpack_public_path__ + "img/card.ab295ec5.png";